import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { RECIPE_CATEGORIES } from './salesData';
import { RECIPES_IMAGE_URL } from '../utils/headMeta';
export function PositioningSection() {
  return <section id="recetas" className="bg-sand py-12 sm:py-16" data-id="element-179" data-mp="v5k809odz1pc">
      <div className="mx-auto max-w-5xl px-5" data-id="element-180" data-mp="v50ztkojfroi">
        <div className="text-center" data-id="element-181" data-mp="q67qm4gaamu5">
          <SectionTag className="bg-white" data-id="element-182" data-mp="q78zc29tux8p">Qué podés vender</SectionTag>
          <h2 className="mx-auto mt-3.5 max-w-[22ch] font-display text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[30ch] sm:text-[2.2rem]" data-id="element-183" data-mp="m4mfoonb8iml">
            Tenés <span className="text-gold" data-id="element-184" data-mp="c6y6wusvdalf">100 recetas para elegir</span>. No 100 recetas para
            preparar de golpe.
          </h2>
        </div>

        <div className="mt-6 overflow-hidden rounded-3xl" data-id="element-185" data-mp="2bjaflqeps83q">
          <img src={RECIPES_IMAGE_URL} alt="Brownies, alfajores, cookies, budines, cheesecake y postres en vaso con frutos rojos" loading="lazy" decoding="async" width={1200} height={800} className="h-[170px] w-full object-cover sm:h-[280px]" data-id="element-186" data-mp="26k7mn4c0dsc4" />
        </div>

        <div className="mt-3 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-187" data-mp="1vi6rhvkt7mif">
          {RECIPE_CATEGORIES.map((cat, i) => <motion.div key={cat.title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 4) * 0.04
        }} className={cat.highlight ? 'rounded-2xl border-2 border-gold bg-white p-4 shadow-[0_20px_44px_-30px_rgba(232,62,115,0.8)] sm:col-span-2 lg:col-span-1' : 'rounded-2xl border border-stone bg-white p-4'} data-id="element-188" data-mp="2o5164buy3rnz" data-mpi={i}>
              {cat.highlight && <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-gold px-2.5 py-1 font-display text-[0.56rem] font-bold uppercase tracking-[0.1em] text-white" data-id="element-189" data-mp="3lpj8jfztmerr">
                  <StarIcon className="h-3 w-3" aria-hidden strokeWidth={3} data-id="element-190" data-mp="3brmykrimdpv8" />
                  Incluye
                </span>}
              <h3 className={`font-display font-bold tracking-tight ${cat.highlight ? 'text-[1.05rem] uppercase text-gold-deep' : 'text-[0.93rem] text-charcoal'}`} data-id="element-191" data-mp="37qjjw8cb5zvl">
                {cat.title}
              </h3>
              <p className="mt-1 font-sans text-[0.82rem] leading-snug text-taupe" data-id="element-192" data-mp="2szkcv1r4fje4">{cat.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}